<div class="container">
    <div class="row justify-content-between">
        <app-breadcrumb [crumbs]="crumbs" class="col"></app-breadcrumb>
        @if (form()?.get('id').value && (Features.PlatformsDetailDelete | hasFeature)) {
            <button (click)="openDelete($event)" color="warn" mat-icon-button>
                <mat-icon fontIcon="fa-trash" fontSet="fas"></mat-icon>
            </button>
        }
    </div>
    @if (form()) {
        <div [formGroup]="form()" class="row gap-3">
            <div class="col-12 col-md-4">
                <b>Naam</b>
                <div class="row">
                    <mat-form-field>
                        <input formControlName="name" matInput name="name" placeholder="Naam">
                    </mat-form-field>
                </div>
            </div>
            <div class="col-12 col-md-4">
                <b>Bedrijf</b>
                <ng-select [items]="companies()" [searchable]="true" bindLabel="name" bindValue="id" formControlName="company_id"></ng-select>
            </div>
            <div class="col-12 col-md-4">
                <b>Productie URL</b>
                <div class="row">
                    <mat-form-field>
                        <input formControlName="prod_url" matInput name="prod_url" placeholder="Productie URL">
                    </mat-form-field>
                </div>
            </div>
            <div class="col-12 col-md-4">
                <b>Productie server IP</b>
                <div class="row">
                    <ng-select [items]="servers()" [searchable]="true" bindLabel="ip" bindValue="ip" formControlName="prod_server_ip"></ng-select>
                </div>
            </div>
            <div class="col-12 col-md-4">
                <b>Acceptie URL</b>
                <div class="row">
                    <mat-form-field>
                        <input formControlName="acc_url" matInput name="acc_url" placeholder="Acceptatie URL">
                    </mat-form-field>
                </div>
            </div>
            <div class="col-12 col-md-4">
                <b>Acceptie server IP</b>
                <div class="row">
                    <ng-select [items]="servers()" [searchable]="true" bindLabel="ip" bindValue="ip" formControlName="acc_server_ip"></ng-select>
                </div>
            </div>
            <div class="col-12 col-md-4">
                <b>Test URL</b>
                <div class="row">
                    <mat-form-field>
                        <input formControlName="test_url" matInput name="test_url" placeholder="Test URL">
                    </mat-form-field>
                </div>
            </div>
            <div class="col-12 col-md-4">
                <b>Test server IP</b>
                <div class="row">
                    <ng-select [items]="servers()" [searchable]="true" bindLabel="ip" bindValue="ip" formControlName="test_server_ip"></ng-select>
                </div>
            </div>
            <div class="col-12 col-md-4">
                <b>Local URL</b>
                <div class="row">
                    <mat-form-field>
                        <input formControlName="local_url" matInput name="local_url" placeholder="Local URL">
                    </mat-form-field>
                </div>
            </div>
            <div class="col-12 col-md-4">
                <b>Startdatum</b>
                <div>
                    <mat-form-field>
                        <input
                            (focus)="pickerStart.open()"
                            [matDatepicker]="pickerStart"
                            [min]="minDate"
                            formControlName="start_date"
                            matInput
                            placeholder="Startdatum">
                        <mat-datepicker-toggle [for]="pickerStart" matSuffix></mat-datepicker-toggle>
                        <mat-datepicker #pickerStart></mat-datepicker>
                        <mat-error [control]="form().get('start_date')"></mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="col-12 col-md-4">
                <b>Einddatum</b>
                <div>
                    <mat-form-field>
                        <input
                            (focus)="pickerEnd.open()"
                            [matDatepicker]="pickerEnd"
                            [min]="minDate"
                            formControlName="end_date"
                            matInput
                            placeholder="Einddatum">
                        <mat-datepicker-toggle [for]="pickerEnd" matSuffix></mat-datepicker-toggle>
                        <mat-datepicker #pickerEnd></mat-datepicker>
                        <mat-error [control]="form().get('end_date')"></mat-error>
                    </mat-form-field>
                </div>
            </div>
            @if (form()?.get('id').value && Functionalities.Financials | hasFunctionality) {
                <div class="col-12 col-md-4">
                    <b>Features</b>
                    <div class="row">
                        <ng-select [items]="azureFeatures()" [multiple]="true" [searchable]="true" bindLabel="name" bindValue="id" formControlName="azure_features"></ng-select>
                    </div>
                </div>
            }
            @if (Features.PlatformsSave | hasFeature) {
                <button (click)="save()" class="btn btn-primary" type="submit">Opslaan</button>
            }
        </div>
    }
</div>

